<template>
  <div class="container">
    <homeHeader title="合同管理"></homeHeader>
    <div class="main">
      <div class="card">
        <!-- 按钮组 -->
        <div class="toolbar-dv">
          <toolBarBtn
            @changeSearchFormShow="changeSearchFormShow"
            :buttonVisible="buttonVisible"
            :moreButtonList="moreButtonList"
            :parentData="this"
            ref="toolBarBtn"
          ></toolBarBtn>
        </div>
        <!-- 查找面板 -->
        <div class="search-dv" v-show="searchFormVisible">
          <SearchForm
            ref="SearchForm"
            v-show="searchFormVisible"
            :searchVuePath="searchVuePath"
            :menuArgs="''"
            @search="sureSearch"
          ></SearchForm>
        </div>
        <!-- 主表信息 -->
        <div class="approve-table-dv">
          <!-- 菜单明细 -->
          <div class="menu-dv" :style="{ height: this.approveCardHeight }">
            <div class="table-dv">
              <vxe-grid
                ref="xTable"
                resizable
                :column-config="{ minWidth: '80px' }"
                :data="tableData"
                :showOverflow="true"
                size="mini"
                :mouse-config="{ area: true }"
                :tooltip-config="{
                  showAll: true,
                  theme: 'dark'
                }"
                :pager-config="tablePage"
                @page-change="handlePageChange"
                :seq-config="{
                  startIndex: (tablePage.currentPage - 1) * tablePage.pageSize
                }"
                highlight-hover-row
                highlight-current-row
                :height="tableHeight"
                :columns="gridColumns"
                @cell-dblclick="handleDblclick"
                :keyboard-config="{
                  isArrow: true,
                  isEnter: true,
                  isTab: true,
                  isClip: true,
                  enterToTab: true,
                  isEdit: true
                }"
                :scroll-y="{
                  mode: 'wheel'
                }"
                :cell-style="cellStyle"
              >
              </vxe-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DetailModal ref="DetailModalRef" @updateData="refresh" />
    <BatchPayDetailModal ref="BatchPayDetailModal" @updateData="refresh"></BatchPayDetailModal>
    <ContractTemplate ref="ContractTemplateRef" />
  </div>
</template>
<script>
import DetailModal from './DetailModal.vue'
import ContractTemplate from '@/views/ContractTemplate/ContractTemplate.vue'
import BatchPayDetailModal from '@/views/ContractManagement/BatchPayDetailModal.vue'
import { getApprover, getState, getSuccessStateByRow } from '@/utils/state'
export default {
  name: 'ContractManagement',
  components: {
    ContractTemplate,
    DetailModal,
    BatchPayDetailModal
  },
  created() {
    this.InitColumn()
  },
  activated() {
    this.list()
  },
  data() {
    return {
      // 按钮组的可见性
      buttonVisible: {
        add: true, // 新增按钮是否显示
        update: false, // 修改按钮
        save: false, // 保存按钮是否显示
        delete: false, // 删除按钮是否显示
        refresh: true, // 刷新数据按钮是否显示
        lock: false, // 锁定按钮是否显示
        unlock: false, // 解锁按钮是否显示
        sort: false, // 排序按钮是否显示
        search: true, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      },
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      // 拓展按钮
      gridColumns: [],
      // 正常状态下，需要加上表格距离card上下的margin
      topBottomMargin: 20,
      // 是否显示查询
      moreButtonList: [{ icon: 'el-icon-tickets', name: '模板', event: 'openTempModal', visible: true }],
      // 查询条件vuepath
      searchFormVisible: false,
      searchVuePath: 'ContractManagement',
      tableData: [],
      // 分页设置
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: this.tablePageConfig.defaultPageSize,
        align: 'right',
        pageSizes: this.tablePageConfig.pageSizes,
        layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
        perfect: true
      }
    }
  },
  methods: {
    openTempModal() {
      this.$refs.ContractTemplateRef.openModal()
    },
    // 初始化
    InitColumn() {
      this.gridColumns = [
        { type: 'seq', width: 40, fixed: 'left' },
        {
          field: 'document_status',
          title: '状态',
          width: '120px',
          slots: {
            default: ({ row }) => {
              return [<span>{getState(row, 'ContractManagement')}</span>]
            }
          }
        },
        {
          field: 'approver',
          title: '已审批人',
          width: '140px',
          slots: {
            default: ({ row }) => {
              return [<span>{getApprover(row, 'ContractManagement')}</span>]
            }
          }
        },
        {
          field: 'is_mailed',
          title: '是否邮寄'
        },
        {
          field: 'company',
          title: '公司'
        },
        {
          field: 'client',
          title: '甲方单位'
        },
        {
          field: 'num',
          title: '合同编号'
        },
        {
          field: 'contract_title',
          title: '合同标题'
        },
        {
          field: 'project_name',
          title: '项目名称'
        },
        {
          field: 'contract_amount',
          title: '合同金额',
          formatter: ['formatAmount', '2', true]
        },
        {
          field: 'receipt_amount_total',
          title: '实际到款金额',
          formatter: ['formatAmount', '2', true]
        },
        {
          field: 'signing_date',
          title: '签订日期',
          formatter: ['formatDate', 'yyyy-MM-dd']
        },
        {
          field: 'validity_date',
          title: '合同到期日',
          formatter: ['formatDate', 'yyyy-MM-dd']
        },
        // {
        //   field: 'isSubmit',
        //   title: '是否已提交',
        //   slots: {
        //     default: ({ row }) => {
        //       return [<span>{row.isSubmit ? '是' : '否'}</span>]
        //     }
        //   }
        // },
        // {
        //   field: 'confirmor',
        //   title: '已确认人'
        // },
        {
          field: 'creator',
          title: '创建者'
        },
        {
          field: 'createTime',
          title: '创建时间',
          formatter: ['formatDate', 'yyyy-MM-dd HH:mm:ss']
        },
        {
          field: 'last_modify_time',
          title: '最后更新时间',
          formatter: ['formatDate', 'yyyy-MM-dd HH:mm:ss']
        },
        {
          field: 'paymentDetail',
          title: '分批付款明细',
          slots: {
            default: ({ row }) => {
              return [
                <el-link type='primary' onClick={() => this.openPayDetail(row)}>
                  查看
                </el-link>
              ]
            }
          }
        },
        {
          field: 'mailingRecipientInfo',
          title: '邮寄信息',
          slots: {
            default: ({ row }) => {
              return [
                <el-link disabled={row.is_mailed !== '是'} type='primary' onClick={() => this.openMailMenu(row)}>
                  查看
                </el-link>
              ]
            }
          }
        }
      ]
    },
    async list() {
      const { data: res } = await this.$http.post('/Finance/Contract/list', {
        pageIndex: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize,
        seeType: this.Authority.seeType,
        searchObjects: this.searchObjects
      })
      if (res.isSuccess) {
        this.tableData = res.data.rows
        this.tablePage.total = res.data.totals
      } else {
        this.$message.error(res.errorMessage)
        return false
      }
    },
    openPayDetail(row) {
      this.$refs.BatchPayDetailModal.openModal(row.id)
    },
    // 查找
    search() {
      this.searchFormVisible = !this.searchFormVisible
    },
    // 双击数据
    handleDblclick({ row }) {
      this.$refs.DetailModalRef.openModal(row.id)
    },
    // 新增
    async add() {
      this.$refs.DetailModalRef.openModal()
    },
    // 页面函数
    changeSearchFormShow() {
      this.searchFormVisible = !this.searchFormVisible
    },
    // 切换查询面板可见性
    handlePageChange({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage
      this.tablePage.pageSize = pageSize
      this.list()
    },
    // 确认查找
    sureSearch(searchObjects) {
      this.searchObjects = searchObjects
      this.tablePage.currentPage = 1
      this.list()
    },
    openMailMenu(row) {
      // 打开邮寄tab
      this.$refs.DetailModalRef.openModal(row.id, 'mailDetail')
    },
    // 刷新数据
    refresh() {
      this.list()
    },
    // 样式
    cellStyle({ row, rowIndex, column, columnIndex }) {
      // 不通过
      const successStyle = {
        backgroundColor: '#2ed573'
      }
      const failedStyle = {
        backgroundColor: '#f56c6c'
      }
      // 财务已处理自己的数据
      if (getSuccessStateByRow(row)) {
        if (column.property === 'document_status') {
          return successStyle
        }
      }
      if (column.property === 'receipt_amount_total') {
        if (row.isRedColor) {
          return failedStyle
        }
      }
    }
  },
  computed: {
    tableHeight() {
      let isSearchForm = this.searchFormVisible
      let isToolBar = true

      // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
      let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
      return this.tableHeightComputed(tableMargin + this.topBottomMargin, isSearchForm, isToolBar)
    },
    // 表格容器高度，需加上margin边距
    approveCardHeight() {
      return this.tableHeight + this.topBottomMargin
    }
  }
}
</script>
<style scoped lang="less">
.main {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - @header-height);
  overflow: hidden;
}
.card {
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
}
.search-dv {
  background-color: aquamarine;
  height: 110px;
  margin: @main-margin 10px;
}

.toolbar-dv {
  padding: 10px;
}

.table-dv {
  padding: @topBottomMargin;
}

.approve-table-dv {
  display: flex;
  // 行高度，需要比 row-config 的 height 多20px，可以让内容与单元格之间有内边距
  // /deep/ .vxe-body--row {
  //   height: 80px !important;
  // }
}
// 权限菜单列表
.menu-dv {
  width: 100%;
}
</style>
